import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer, MobileCallBar } from "./components/Footer";
import { SmoothScroll, ScrollManager } from "./components/SmoothScroll";
import HomePage from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import BookPage from "./pages/Book";
import { ResidentialHub, CommercialHub } from "./pages/Hubs";
import { AboutPage, ContactPage, ProcessPage, ProjectsPage, ReviewsPage } from "./pages/Pages";
import { CityPage, ServiceAreasPage } from "./pages/City";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <ScrollManager />
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-flame focus:px-4 focus:py-2 focus:text-navy">Skip to content</a>
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/residential" element={<ResidentialHub />} />
            <Route path="/residential/interior" element={<ServicePage pageKey="interior" />} />
            <Route path="/residential/exterior" element={<ServicePage pageKey="exterior" />} />
            <Route path="/residential/cabinets" element={<ServicePage pageKey="cabinets" />} />
            <Route path="/commercial" element={<CommercialHub />} />
            <Route path="/commercial/offices" element={<ServicePage pageKey="offices" />} />
            <Route path="/commercial/hospitality" element={<ServicePage pageKey="hospitality" />} />
            <Route path="/commercial/high-rise-multi-unit" element={<ServicePage pageKey="high-rise" />} />
            <Route path="/our-process" element={<ProcessPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/painters/:slug" element={<CityPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <MobileCallBar />
        <Toaster position="top-center" richColors />
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
